export default "__VITE_ASSET__BEnuOKp8__ 400w, __VITE_ASSET__B1dJLUpY__ 640w, __VITE_ASSET__DrvbHZCf__ 896w";